export default "__VITE_ASSET__CesCzyNt__"